import { Component } from '@angular/core';

import { SedsPositionsOptions } from '../../shared/enums/seds-positions-options.enum';

@Component({
    selector: 'seds-tooltip',
    templateUrl: './seds-tooltip.component.html',
    styleUrls: ['./seds-tooltip.component.scss'],
    standalone: false
})
export class SedsTooltipComponent {
  public left = 0;
  public position: SedsPositionsOptions | string = 'below';
  public sedsTooltip = '';
  public top = 0;
  public visible = false;
}
